"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventorySource = exports.IndustryType = exports.IndustryGroupType = exports.FleetSegments = exports.FleetOperation = exports.FinanceProgramType = exports.FinanceProgramStructure = exports.FinanceProgramRateType = exports.FieldInputType = exports.FastTrackStatus = exports.FastTrackSetting = exports.FastTrackLogStatus = exports.FarmingStatusType = exports.FarmType = exports.FdrType = exports.FdrStatus = exports.ExternalCrmSource = exports.EquipmentType = exports.EquipmentCondition = exports.EquipmentApprovalStatus = exports.EDocStatus = exports.DocumentType = exports.DocUploadSetting = exports.DiscountedOrBrokered = exports.DiscountType = exports.DepartmentName = exports.DeliveryStatus = exports.DealSheetCreationTriggerEvent = exports.CreditSubmissionLenderDisplayNotify = exports.CreditSubmissionFailureStatus = exports.CreditSubmissionArchiveStatusId = exports.CreditReporterCode = exports.CreditLineStatus = exports.CreditBureauType = exports.CreditApplicationLenderType = exports.CreditApplicationEntityType = exports.ContractType = exports.BusinessOrIndividual = exports.BusinessCreditReportPullInDealerPortal = exports.BizOrIndividual = exports.ApplyingFor = exports.ApplicationType = exports.ApplicationStage = exports.ApplicantType = exports.AftermarketProductVendorApiChannel = exports.AftermarketProductType = exports.AftermarketProductCategory = exports.AdminRole = exports.ActivityStatus = exports.AccountType = void 0;
exports.InboundDealType = exports.WebhookEventType = exports.VendorOpportunityStage = exports.VendorContactRole = exports.UserType = exports.UsCitizen = exports.TruckType = exports.TiersType = exports.TaxTreatment = exports.SubsidyCapType = exports.SubmitProposalOptionActionType = exports.SourceType = exports.SoftPullInDealerPortal = exports.SaleType = exports.ResidentStatusType = exports.RequiredStatusType = exports.ReferenceType = exports.QuoteFeeType = exports.QuoteAftermarketProductType = exports.ProvidingInsuranceType = exports.ProposalSaleType = exports.ProposalMenuOptionType = exports.ProposalContractAftermarketVendorDataStatus = exports.ProposalCategory = exports.ProcessType = exports.ProcessTriggerType = exports.PrequalStatus = exports.PreFundingSource = exports.PortalConfigurationType = exports.PaymentType = exports.PaymentPeriodTiming = exports.PartnerProfileStatuses = exports.PsChannel = exports.OwnershipType = exports.OperatingLine = exports.MedicalPractice = exports.MarkupType = exports.MaritalStatusType = exports.LenderWaterfallPrescreenCriteriaResultType = exports.LenderType = exports.LenderProfileOcaTemplateType = exports.LenderProfileOcaBrandingType = exports.LenderProfileOcaAutoSubmissionType = exports.LenderContactRole = exports.LeadStatusType = exports.Lms = exports.Lender_Submission_Review_Show_Mapping_Modal_Setting = void 0;
var AccountType;
(function (AccountType) {
    AccountType["Dealer"] = "DEALER";
    AccountType["Lender"] = "LENDER";
})(AccountType || (exports.AccountType = AccountType = {}));
var ActivityStatus;
(function (ActivityStatus) {
    ActivityStatus["Cancelled"] = "Cancelled";
    ActivityStatus["Completed"] = "Completed";
    ActivityStatus["Scheduled"] = "Scheduled";
})(ActivityStatus || (exports.ActivityStatus = ActivityStatus = {}));
var AdminRole;
(function (AdminRole) {
    AdminRole["SingleAccountOnly"] = "single_account_only";
    AdminRole["Super"] = "super";
})(AdminRole || (exports.AdminRole = AdminRole = {}));
var AftermarketProductCategory;
(function (AftermarketProductCategory) {
    AftermarketProductCategory["Gap"] = "GAP";
    AftermarketProductCategory["Insurance"] = "INSURANCE";
    AftermarketProductCategory["None"] = "NONE";
    AftermarketProductCategory["Roadside"] = "ROADSIDE";
    AftermarketProductCategory["ServiceContract"] = "SERVICE_CONTRACT";
})(AftermarketProductCategory || (exports.AftermarketProductCategory = AftermarketProductCategory = {}));
var AftermarketProductType;
(function (AftermarketProductType) {
    AftermarketProductType["Addon"] = "ADDON";
    AftermarketProductType["Product"] = "PRODUCT";
})(AftermarketProductType || (exports.AftermarketProductType = AftermarketProductType = {}));
var AftermarketProductVendorApiChannel;
(function (AftermarketProductVendorApiChannel) {
    AftermarketProductVendorApiChannel["Gaig"] = "GAIG";
    AftermarketProductVendorApiChannel["Ntp"] = "NTP";
})(AftermarketProductVendorApiChannel || (exports.AftermarketProductVendorApiChannel = AftermarketProductVendorApiChannel = {}));
var ApplicantType;
(function (ApplicantType) {
    ApplicantType["Ag"] = "ag";
    ApplicantType["CommercialUse"] = "commercial_use";
    ApplicantType["Fleet"] = "fleet";
    ApplicantType["NonCommercialUse"] = "non_commercial_use";
    ApplicantType["OwnerOperator"] = "owner_operator";
    ApplicantType["Vocational"] = "vocational";
})(ApplicantType || (exports.ApplicantType = ApplicantType = {}));
var ApplicationStage;
(function (ApplicationStage) {
    ApplicationStage["Approved"] = "approved";
    ApplicationStage["Cancelled"] = "cancelled";
    ApplicationStage["CustomerCancelled"] = "customer_cancelled";
    ApplicationStage["DealerCancelled"] = "dealer_cancelled";
    ApplicationStage["Declined"] = "declined";
    ApplicationStage["Funded"] = "funded";
    ApplicationStage["PreQualified"] = "pre_qualified";
    ApplicationStage["Prospect"] = "prospect";
})(ApplicationStage || (exports.ApplicationStage = ApplicationStage = {}));
var ApplicationType;
(function (ApplicationType) {
    ApplicationType["Commercial"] = "COMMERCIAL";
    ApplicationType["CommercialWithGuarantor"] = "COMMERCIAL_WITH_GUARANTOR";
    ApplicationType["CommercialWithMultipleGuarantors"] = "COMMERCIAL_WITH_MULTIPLE_GUARANTORS";
    ApplicationType["Individual"] = "INDIVIDUAL";
    ApplicationType["IndividualWithSecondGuarantor"] = "INDIVIDUAL_WITH_SECOND_GUARANTOR";
})(ApplicationType || (exports.ApplicationType = ApplicationType = {}));
var ApplyingFor;
(function (ApplyingFor) {
    ApplyingFor["Aftermarket"] = "aftermarket";
    ApplyingFor["CatCard"] = "catCard";
    ApplyingFor["CreditLine"] = "creditLine";
    ApplyingFor["EquipmentFinancing"] = "equipmentFinancing";
    ApplyingFor["Lease"] = "lease";
    ApplyingFor["OemCard"] = "oemCard";
})(ApplyingFor || (exports.ApplyingFor = ApplyingFor = {}));
var BizOrIndividual;
(function (BizOrIndividual) {
    BizOrIndividual["Business"] = "business";
    BizOrIndividual["Individual"] = "individual";
})(BizOrIndividual || (exports.BizOrIndividual = BizOrIndividual = {}));
var BusinessCreditReportPullInDealerPortal;
(function (BusinessCreditReportPullInDealerPortal) {
    BusinessCreditReportPullInDealerPortal["CreditsafeFullReport"] = "CREDITSAFE_FULL_REPORT";
    BusinessCreditReportPullInDealerPortal["Off"] = "OFF";
    BusinessCreditReportPullInDealerPortal["Paynet"] = "PAYNET";
    BusinessCreditReportPullInDealerPortal["Preview"] = "PREVIEW";
})(BusinessCreditReportPullInDealerPortal || (exports.BusinessCreditReportPullInDealerPortal = BusinessCreditReportPullInDealerPortal = {}));
var BusinessOrIndividual;
(function (BusinessOrIndividual) {
    BusinessOrIndividual["Business"] = "BUSINESS";
    BusinessOrIndividual["Individual"] = "INDIVIDUAL";
})(BusinessOrIndividual || (exports.BusinessOrIndividual = BusinessOrIndividual = {}));
var ContractType;
(function (ContractType) {
    ContractType["Lease"] = "lease";
    ContractType["Loan"] = "loan";
    ContractType["Trac"] = "trac";
})(ContractType || (exports.ContractType = ContractType = {}));
var CreditApplicationEntityType;
(function (CreditApplicationEntityType) {
    CreditApplicationEntityType["CashSale"] = "CASH_SALE";
    CreditApplicationEntityType["CreditApp"] = "CREDIT_APP";
    CreditApplicationEntityType["LeadProposal"] = "LEAD_PROPOSAL";
})(CreditApplicationEntityType || (exports.CreditApplicationEntityType = CreditApplicationEntityType = {}));
var CreditApplicationLenderType;
(function (CreditApplicationLenderType) {
    CreditApplicationLenderType["Approved"] = "APPROVED";
    CreditApplicationLenderType["Declined"] = "DECLINED";
    CreditApplicationLenderType["ExternalApiError"] = "EXTERNAL_API_ERROR";
    CreditApplicationLenderType["PaymentsGenerated"] = "PAYMENTS_GENERATED";
    CreditApplicationLenderType["PreApproved"] = "PRE_APPROVED";
    CreditApplicationLenderType["Proposal"] = "PROPOSAL";
})(CreditApplicationLenderType || (exports.CreditApplicationLenderType = CreditApplicationLenderType = {}));
var CreditBureauType;
(function (CreditBureauType) {
    CreditBureauType["Clarity"] = "CLARITY";
    CreditBureauType["Equifax"] = "EQUIFAX";
    CreditBureauType["Experian"] = "EXPERIAN";
    CreditBureauType["Ofac"] = "OFAC";
    CreditBureauType["TransUnion"] = "TRANS_UNION";
})(CreditBureauType || (exports.CreditBureauType = CreditBureauType = {}));
var CreditLineStatus;
(function (CreditLineStatus) {
    CreditLineStatus["Approved"] = "APPROVED";
    CreditLineStatus["Declined"] = "DECLINED";
    CreditLineStatus["Pending"] = "PENDING";
})(CreditLineStatus || (exports.CreditLineStatus = CreditLineStatus = {}));
var CreditReporterCode;
(function (CreditReporterCode) {
    CreditReporterCode["Cbc"] = "CBC";
    CreditReporterCode["CbcOfac"] = "CBC_OFAC";
    CreditReporterCode["Creditsafe"] = "CREDITSAFE";
    CreditReporterCode["LegacyCrm"] = "LEGACY_CRM";
    CreditReporterCode["Paynet"] = "PAYNET";
})(CreditReporterCode || (exports.CreditReporterCode = CreditReporterCode = {}));
var CreditSubmissionArchiveStatusId;
(function (CreditSubmissionArchiveStatusId) {
    CreditSubmissionArchiveStatusId["Active_100"] = "ACTIVE_100";
    CreditSubmissionArchiveStatusId["ArchivedDuplicate_201"] = "ARCHIVED_DUPLICATE_201";
    CreditSubmissionArchiveStatusId["ArchivedOther_202"] = "ARCHIVED_OTHER_202";
    CreditSubmissionArchiveStatusId["ArchivedTesting_200"] = "ARCHIVED_TESTING_200";
})(CreditSubmissionArchiveStatusId || (exports.CreditSubmissionArchiveStatusId = CreditSubmissionArchiveStatusId = {}));
var CreditSubmissionFailureStatus;
(function (CreditSubmissionFailureStatus) {
    CreditSubmissionFailureStatus["Canceled"] = "CANCELED";
    CreditSubmissionFailureStatus["Pending"] = "PENDING";
    CreditSubmissionFailureStatus["Resolved"] = "RESOLVED";
    CreditSubmissionFailureStatus["Reviewed"] = "REVIEWED";
})(CreditSubmissionFailureStatus || (exports.CreditSubmissionFailureStatus = CreditSubmissionFailureStatus = {}));
var CreditSubmissionLenderDisplayNotify;
(function (CreditSubmissionLenderDisplayNotify) {
    CreditSubmissionLenderDisplayNotify["FtCreatedHideInLpUntilProposalSent"] = "FT_CREATED_HIDE_IN_LP_UNTIL_PROPOSAL_SENT";
    CreditSubmissionLenderDisplayNotify["FtDealerAccepted"] = "FT_DEALER_ACCEPTED";
    CreditSubmissionLenderDisplayNotify["FtDocsRequestedFromLender"] = "FT_DOCS_REQUESTED_FROM_LENDER";
    CreditSubmissionLenderDisplayNotify["FtFunded"] = "FT_FUNDED";
    CreditSubmissionLenderDisplayNotify["FtLenderDocsSent"] = "FT_LENDER_DOCS_SENT";
    CreditSubmissionLenderDisplayNotify["FtProposalAccepted"] = "FT_PROPOSAL_ACCEPTED";
})(CreditSubmissionLenderDisplayNotify || (exports.CreditSubmissionLenderDisplayNotify = CreditSubmissionLenderDisplayNotify = {}));
var DealSheetCreationTriggerEvent;
(function (DealSheetCreationTriggerEvent) {
    DealSheetCreationTriggerEvent["CreditSubmissionCreated"] = "CREDIT_SUBMISSION_CREATED";
    DealSheetCreationTriggerEvent["CreditSubmissionUpdated"] = "CREDIT_SUBMISSION_UPDATED";
    DealSheetCreationTriggerEvent["ExternalCrmVendorOpportunityReceived"] = "EXTERNAL_CRM_VENDOR_OPPORTUNITY_RECEIVED";
})(DealSheetCreationTriggerEvent || (exports.DealSheetCreationTriggerEvent = DealSheetCreationTriggerEvent = {}));
var DeliveryStatus;
(function (DeliveryStatus) {
    DeliveryStatus["BackOrdered"] = "back_ordered";
    DeliveryStatus["Cancelled"] = "cancelled";
    DeliveryStatus["DaComplete"] = "da_complete";
    DeliveryStatus["DeliveredPendingDa"] = "delivered_pending_da";
    DeliveryStatus["OrderPending"] = "order_pending";
    DeliveryStatus["Shipped"] = "shipped";
})(DeliveryStatus || (exports.DeliveryStatus = DeliveryStatus = {}));
var DepartmentName;
(function (DepartmentName) {
    DepartmentName["Accounting"] = "ACCOUNTING";
    DepartmentName["Finance"] = "FINANCE";
    DepartmentName["Operations"] = "OPERATIONS";
    DepartmentName["Sales"] = "SALES";
})(DepartmentName || (exports.DepartmentName = DepartmentName = {}));
var DiscountType;
(function (DiscountType) {
    DiscountType["Flat"] = "flat";
    DiscountType["Percent"] = "percent";
})(DiscountType || (exports.DiscountType = DiscountType = {}));
var DiscountedOrBrokered;
(function (DiscountedOrBrokered) {
    DiscountedOrBrokered["Brokered"] = "Brokered";
    DiscountedOrBrokered["Discounted"] = "Discounted";
})(DiscountedOrBrokered || (exports.DiscountedOrBrokered = DiscountedOrBrokered = {}));
var DocUploadSetting;
(function (DocUploadSetting) {
    DocUploadSetting["Disabled"] = "disabled";
    DocUploadSetting["Enabled"] = "enabled";
})(DocUploadSetting || (exports.DocUploadSetting = DocUploadSetting = {}));
var DocumentType;
(function (DocumentType) {
    DocumentType["Addendum"] = "addendum";
    DocumentType["BankStatements"] = "bank_statements";
    DocumentType["BuyersOrder"] = "buyers_order";
    DocumentType["Compliance"] = "compliance";
    DocumentType["CreditAppScan"] = "credit_app_scan";
    DocumentType["CreditReport"] = "credit_report";
    DocumentType["DecisionLetter"] = "decision_letter";
    DocumentType["DriverLicense"] = "driver_license";
    DocumentType["EquipmentSpecs"] = "equipment_specs";
    DocumentType["Financial"] = "financial";
    DocumentType["InsuranceCertificate"] = "insurance_certificate";
    DocumentType["Invoice"] = "invoice";
    DocumentType["Other"] = "other";
    DocumentType["Quote"] = "quote";
    DocumentType["SalesTaxExemption"] = "sales_tax_exemption";
    DocumentType["TaxReturns"] = "tax_returns";
})(DocumentType || (exports.DocumentType = DocumentType = {}));
var EDocStatus;
(function (EDocStatus) {
    EDocStatus["AwaitingDocuSignCreation"] = "Awaiting_DocuSign_Creation";
    EDocStatus["Canceled"] = "Canceled";
    EDocStatus["DocsReceived"] = "Docs_Received";
    EDocStatus["DocsSent"] = "Docs_Sent";
    EDocStatus["DocsSigned"] = "Docs_Signed";
    EDocStatus["Draft"] = "Draft";
    EDocStatus["Error"] = "Error";
})(EDocStatus || (exports.EDocStatus = EDocStatus = {}));
var EquipmentApprovalStatus;
(function (EquipmentApprovalStatus) {
    EquipmentApprovalStatus["Approved"] = "approved";
    EquipmentApprovalStatus["No"] = "no";
    EquipmentApprovalStatus["NotApproved"] = "not_approved";
    EquipmentApprovalStatus["Submitted"] = "submitted";
})(EquipmentApprovalStatus || (exports.EquipmentApprovalStatus = EquipmentApprovalStatus = {}));
var EquipmentCondition;
(function (EquipmentCondition) {
    EquipmentCondition["Demo"] = "demo";
    EquipmentCondition["New"] = "new";
    EquipmentCondition["Reconditioned"] = "reconditioned";
    EquipmentCondition["Used"] = "used";
})(EquipmentCondition || (exports.EquipmentCondition = EquipmentCondition = {}));
var EquipmentType;
(function (EquipmentType) {
    EquipmentType["Purchase"] = "PURCHASE";
    EquipmentType["TradeIn"] = "TRADE_IN";
})(EquipmentType || (exports.EquipmentType = EquipmentType = {}));
var ExternalCrmSource;
(function (ExternalCrmSource) {
    ExternalCrmSource["Arcadium"] = "ARCADIUM";
})(ExternalCrmSource || (exports.ExternalCrmSource = ExternalCrmSource = {}));
var FdrStatus;
(function (FdrStatus) {
    FdrStatus["Canceled"] = "Canceled";
    FdrStatus["DocsIn"] = "Docs_In";
    FdrStatus["DocsOut"] = "Docs_Out";
    FdrStatus["New"] = "New";
    FdrStatus["Pending"] = "Pending";
    FdrStatus["Submitted"] = "Submitted";
})(FdrStatus || (exports.FdrStatus = FdrStatus = {}));
var FdrType;
(function (FdrType) {
    FdrType["Efa"] = "EFA";
    FdrType["Lease"] = "Lease";
    FdrType["Loan"] = "Loan";
    FdrType["WorkingCapital"] = "Working_Capital";
})(FdrType || (exports.FdrType = FdrType = {}));
var FarmType;
(function (FarmType) {
    FarmType["FarmerRancher"] = "FARMER_RANCHER";
    FarmType["FarmRelatedServiceBusiness"] = "FARM_RELATED_SERVICE_BUSINESS";
    FarmType["Other"] = "OTHER";
})(FarmType || (exports.FarmType = FarmType = {}));
var FarmingStatusType;
(function (FarmingStatusType) {
    FarmingStatusType["FullTime"] = "FULL_TIME";
    FarmingStatusType["PartTime"] = "PART_TIME";
})(FarmingStatusType || (exports.FarmingStatusType = FarmingStatusType = {}));
var FastTrackLogStatus;
(function (FastTrackLogStatus) {
    FastTrackLogStatus["Error"] = "ERROR";
    FastTrackLogStatus["Info"] = "INFO";
    FastTrackLogStatus["Success"] = "SUCCESS";
    FastTrackLogStatus["Warning"] = "WARNING";
})(FastTrackLogStatus || (exports.FastTrackLogStatus = FastTrackLogStatus = {}));
var FastTrackSetting;
(function (FastTrackSetting) {
    FastTrackSetting["FtOffCamundaProcessCodeWillRunOnAppReceipt"] = "FT_OFF_CAMUNDA_PROCESS_CODE_WILL_RUN_ON_APP_RECEIPT";
    FastTrackSetting["NoFtOff"] = "NO_FT_OFF";
    FastTrackSetting["YesAutomatedForDealer"] = "YES_AUTOMATED_FOR_DEALER";
    FastTrackSetting["YesButDealerMustTrigger"] = "YES_BUT_DEALER_MUST_TRIGGER";
    FastTrackSetting["YesSetCamundaProcessCode"] = "YES_SET_CAMUNDA_PROCESS_CODE";
})(FastTrackSetting || (exports.FastTrackSetting = FastTrackSetting = {}));
var FastTrackStatus;
(function (FastTrackStatus) {
    FastTrackStatus["AwaitingDealerApproval"] = "AWAITING_DEALER_APPROVAL";
    FastTrackStatus["AwaitingLenderApproval"] = "AWAITING_LENDER_APPROVAL";
    FastTrackStatus["Cancelled"] = "CANCELLED";
    FastTrackStatus["DocsOut"] = "DOCS_OUT";
    FastTrackStatus["FundedFast"] = "FUNDED_FAST";
    FastTrackStatus["InFunding"] = "IN_FUNDING";
    FastTrackStatus["LenderDeclined"] = "LENDER_DECLINED";
    FastTrackStatus["PrescreenFailed"] = "PRESCREEN_FAILED";
    FastTrackStatus["ProposalAccepted"] = "PROPOSAL_ACCEPTED";
    FastTrackStatus["ProposalSent"] = "PROPOSAL_SENT";
    FastTrackStatus["ProposalViewed"] = "PROPOSAL_VIEWED";
    FastTrackStatus["RequiresDealerAttention"] = "REQUIRES_DEALER_ATTENTION";
})(FastTrackStatus || (exports.FastTrackStatus = FastTrackStatus = {}));
var FieldInputType;
(function (FieldInputType) {
    FieldInputType["Checkbox"] = "CHECKBOX";
    FieldInputType["Country"] = "COUNTRY";
    FieldInputType["CountryCode"] = "COUNTRY_CODE";
    FieldInputType["Date"] = "DATE";
    FieldInputType["Day"] = "DAY";
    FieldInputType["Fein"] = "FEIN";
    FieldInputType["Float"] = "FLOAT";
    FieldInputType["Initials"] = "INITIALS";
    FieldInputType["Integer"] = "INTEGER";
    FieldInputType["Money"] = "MONEY";
    FieldInputType["Month"] = "MONTH";
    FieldInputType["OptionSet"] = "OPTION_SET";
    FieldInputType["PhoneNumber"] = "PHONE_NUMBER";
    FieldInputType["Ssn"] = "SSN";
    FieldInputType["State"] = "STATE";
    FieldInputType["StateAbbr"] = "STATE_ABBR";
    FieldInputType["String"] = "STRING";
    FieldInputType["Year"] = "YEAR";
})(FieldInputType || (exports.FieldInputType = FieldInputType = {}));
var FinanceProgramRateType;
(function (FinanceProgramRateType) {
    FinanceProgramRateType["InterestRate"] = "INTEREST_RATE";
    FinanceProgramRateType["RateFactor"] = "RATE_FACTOR";
})(FinanceProgramRateType || (exports.FinanceProgramRateType = FinanceProgramRateType = {}));
var FinanceProgramStructure;
(function (FinanceProgramStructure) {
    FinanceProgramStructure["InternalCreditTiers"] = "INTERNAL_CREDIT_TIERS";
    FinanceProgramStructure["Scorecard"] = "SCORECARD";
})(FinanceProgramStructure || (exports.FinanceProgramStructure = FinanceProgramStructure = {}));
var FinanceProgramType;
(function (FinanceProgramType) {
    FinanceProgramType["Efa"] = "EFA";
    FinanceProgramType["Lease"] = "LEASE";
    FinanceProgramType["Loan"] = "LOAN";
})(FinanceProgramType || (exports.FinanceProgramType = FinanceProgramType = {}));
var FleetOperation;
(function (FleetOperation) {
    FleetOperation["Interstate"] = "interstate";
    FleetOperation["Intrastate"] = "intrastate";
    FleetOperation["Local"] = "local";
    FleetOperation["Regional"] = "regional";
})(FleetOperation || (exports.FleetOperation = FleetOperation = {}));
var FleetSegments;
(function (FleetSegments) {
    FleetSegments["GeneralFreight"] = "general_freight";
    FleetSegments["LessTheTruckload"] = "less_the_truckload";
    FleetSegments["Other"] = "other";
    FleetSegments["Truckload"] = "truckload";
})(FleetSegments || (exports.FleetSegments = FleetSegments = {}));
var IndustryGroupType;
(function (IndustryGroupType) {
    IndustryGroupType["Generic"] = "generic";
    IndustryGroupType["Medical"] = "medical";
    IndustryGroupType["Restaurant"] = "restaurant";
    IndustryGroupType["Trucking"] = "trucking";
})(IndustryGroupType || (exports.IndustryGroupType = IndustryGroupType = {}));
var IndustryType;
(function (IndustryType) {
    IndustryType["Agriculture"] = "agriculture";
    IndustryType["Beverage"] = "beverage";
    IndustryType["BuildingContractor"] = "building_contractor";
    IndustryType["Construction"] = "construction";
    IndustryType["Crane"] = "crane";
    IndustryType["CustomNationalOperator"] = "custom_national_operator";
    IndustryType["CustomRegionalOperator"] = "custom_regional_operator";
    IndustryType["Dealer"] = "dealer";
    IndustryType["DealerPrincipal"] = "dealer_principal";
    IndustryType["Delivery"] = "delivery";
    IndustryType["DentistOrthodontist"] = "dentist_orthodontist";
    IndustryType["ExcavatingGradingTrenching"] = "excavating_grading_trenching";
    IndustryType["FoodGrocery"] = "food_grocery";
    IndustryType["Forestry"] = "forestry";
    IndustryType["FullTimeFarmer"] = "full_time_farmer";
    IndustryType["HazardousToxic"] = "hazardous_toxic";
    IndustryType["Landscape"] = "landscape";
    IndustryType["Landscaping"] = "landscaping";
    IndustryType["LawnGroundCare"] = "lawn_ground_care";
    IndustryType["Logging"] = "logging";
    IndustryType["Manufacturing"] = "manufacturing";
    IndustryType["MaterialHandling"] = "material_handling";
    IndustryType["Mining"] = "mining";
    IndustryType["Mixer"] = "mixer";
    IndustryType["Municipal"] = "municipal";
    IndustryType["Oilfield"] = "oilfield";
    IndustryType["Optometrist"] = "optometrist";
    IndustryType["Other"] = "other";
    IndustryType["PartTimeFarmer"] = "part_time_farmer";
    IndustryType["Physician"] = "physician";
    IndustryType["Podiatrist"] = "podiatrist";
    IndustryType["Refuse"] = "refuse";
    IndustryType["RentalHouse"] = "rental_house";
    IndustryType["RentalYard"] = "rental_yard";
    IndustryType["RoadStreet"] = "road_street";
    IndustryType["Tank"] = "tank";
    IndustryType["TowRecovery"] = "tow_recovery";
    IndustryType["Transportation"] = "transportation";
    IndustryType["Veterinarian"] = "veterinarian";
})(IndustryType || (exports.IndustryType = IndustryType = {}));
var InventorySource;
(function (InventorySource) {
    InventorySource["Arcadium"] = "ARCADIUM";
})(InventorySource || (exports.InventorySource = InventorySource = {}));
var Lender_Submission_Review_Show_Mapping_Modal_Setting;
(function (Lender_Submission_Review_Show_Mapping_Modal_Setting) {
    Lender_Submission_Review_Show_Mapping_Modal_Setting["OffNoReviewShown"] = "OFF_NO_REVIEW_SHOWN";
    Lender_Submission_Review_Show_Mapping_Modal_Setting["OnDisplaysMappingModal"] = "ON_DISPLAYS_MAPPING_MODAL";
})(Lender_Submission_Review_Show_Mapping_Modal_Setting || (exports.Lender_Submission_Review_Show_Mapping_Modal_Setting = Lender_Submission_Review_Show_Mapping_Modal_Setting = {}));
var Lms;
(function (Lms) {
    Lms["GreatAmerica"] = "GREAT_AMERICA";
    Lms["Leasecomplete"] = "LEASECOMPLETE";
})(Lms || (exports.Lms = Lms = {}));
var LeadStatusType;
(function (LeadStatusType) {
    LeadStatusType["Duplicate"] = "DUPLICATE";
    LeadStatusType["Master"] = "MASTER";
})(LeadStatusType || (exports.LeadStatusType = LeadStatusType = {}));
var LenderContactRole;
(function (LenderContactRole) {
    LenderContactRole["AccountMgr"] = "account_mgr";
    LenderContactRole["CreditOfficer"] = "credit_officer";
    LenderContactRole["Executive"] = "executive";
    LenderContactRole["FundingCoord"] = "funding_coord";
    LenderContactRole["SalesAsst"] = "sales_asst";
    LenderContactRole["SalesMgr"] = "sales_mgr";
})(LenderContactRole || (exports.LenderContactRole = LenderContactRole = {}));
var LenderProfileOcaAutoSubmissionType;
(function (LenderProfileOcaAutoSubmissionType) {
    LenderProfileOcaAutoSubmissionType["No"] = "NO";
    LenderProfileOcaAutoSubmissionType["Yes"] = "YES";
})(LenderProfileOcaAutoSubmissionType || (exports.LenderProfileOcaAutoSubmissionType = LenderProfileOcaAutoSubmissionType = {}));
var LenderProfileOcaBrandingType;
(function (LenderProfileOcaBrandingType) {
    LenderProfileOcaBrandingType["CoBranded"] = "CO_BRANDED";
    LenderProfileOcaBrandingType["Dealer"] = "DEALER";
    LenderProfileOcaBrandingType["Lender"] = "LENDER";
})(LenderProfileOcaBrandingType || (exports.LenderProfileOcaBrandingType = LenderProfileOcaBrandingType = {}));
var LenderProfileOcaTemplateType;
(function (LenderProfileOcaTemplateType) {
    LenderProfileOcaTemplateType["Dealer"] = "DEALER";
    LenderProfileOcaTemplateType["Lender"] = "LENDER";
})(LenderProfileOcaTemplateType || (exports.LenderProfileOcaTemplateType = LenderProfileOcaTemplateType = {}));
var LenderType;
(function (LenderType) {
    LenderType["Afg"] = "AFG";
    LenderType["Amur"] = "AMUR";
    LenderType["Cit"] = "CIT";
    LenderType["ClickLease"] = "CLICK_LEASE";
    LenderType["Cnh"] = "CNH";
    LenderType["Dfs"] = "DFS";
    LenderType["Diesel"] = "DIESEL";
    LenderType["Dll"] = "DLL";
    LenderType["Dtfs"] = "DTFS";
    LenderType["Engs"] = "ENGS";
    LenderType["FinPac"] = "FIN_PAC";
    LenderType["LenderMatrix"] = "LENDER_MATRIX";
    LenderType["Peac"] = "PEAC";
    LenderType["RouteOne"] = "ROUTE_ONE";
    LenderType["Sheffield"] = "SHEFFIELD";
    LenderType["Vfs"] = "VFS";
})(LenderType || (exports.LenderType = LenderType = {}));
var LenderWaterfallPrescreenCriteriaResultType;
(function (LenderWaterfallPrescreenCriteriaResultType) {
    LenderWaterfallPrescreenCriteriaResultType["Error"] = "ERROR";
    LenderWaterfallPrescreenCriteriaResultType["Fail"] = "FAIL";
    LenderWaterfallPrescreenCriteriaResultType["FailWarning"] = "FAIL_WARNING";
    LenderWaterfallPrescreenCriteriaResultType["Pass"] = "PASS";
    LenderWaterfallPrescreenCriteriaResultType["PassWarning"] = "PASS_WARNING";
})(LenderWaterfallPrescreenCriteriaResultType || (exports.LenderWaterfallPrescreenCriteriaResultType = LenderWaterfallPrescreenCriteriaResultType = {}));
var MaritalStatusType;
(function (MaritalStatusType) {
    MaritalStatusType["Married"] = "MARRIED";
    MaritalStatusType["Separated"] = "SEPARATED";
    MaritalStatusType["UnmarriedSingleWidowedDivorced"] = "UNMARRIED_SINGLE_WIDOWED_DIVORCED";
})(MaritalStatusType || (exports.MaritalStatusType = MaritalStatusType = {}));
var MarkupType;
(function (MarkupType) {
    MarkupType["Flat"] = "FLAT";
    MarkupType["Percentage"] = "PERCENTAGE";
})(MarkupType || (exports.MarkupType = MarkupType = {}));
var MedicalPractice;
(function (MedicalPractice) {
    MedicalPractice["Dentist"] = "dentist";
    MedicalPractice["Doctor"] = "doctor";
    MedicalPractice["Optometrist"] = "optometrist";
    MedicalPractice["Other"] = "other";
    MedicalPractice["Podiatrist"] = "podiatrist";
    MedicalPractice["Veterinarian"] = "veterinarian";
})(MedicalPractice || (exports.MedicalPractice = MedicalPractice = {}));
var OperatingLine;
(function (OperatingLine) {
    OperatingLine["AccountsReceivable"] = "accounts_receivable";
    OperatingLine["AllAssets"] = "all_assets";
    OperatingLine["Other"] = "other";
    OperatingLine["PersonalGuaranty"] = "personal_guaranty";
})(OperatingLine || (exports.OperatingLine = OperatingLine = {}));
var OwnershipType;
(function (OwnershipType) {
    OwnershipType["EffectiveControl"] = "effective_control";
    OwnershipType["ExecutiveManagement"] = "executive_management";
    OwnershipType["Ownership"] = "ownership";
})(OwnershipType || (exports.OwnershipType = OwnershipType = {}));
var PsChannel;
(function (PsChannel) {
    PsChannel["Both"] = "both";
    PsChannel["Crm"] = "crm";
    PsChannel["None"] = "none";
    PsChannel["Postgres"] = "postgres";
})(PsChannel || (exports.PsChannel = PsChannel = {}));
var PartnerProfileStatuses;
(function (PartnerProfileStatuses) {
    PartnerProfileStatuses["Active"] = "Active";
    PartnerProfileStatuses["Onboarding"] = "Onboarding";
    PartnerProfileStatuses["Staged"] = "Staged";
})(PartnerProfileStatuses || (exports.PartnerProfileStatuses = PartnerProfileStatuses = {}));
var PaymentPeriodTiming;
(function (PaymentPeriodTiming) {
    PaymentPeriodTiming["BeginningOfPeriod"] = "BEGINNING_OF_PERIOD";
    PaymentPeriodTiming["EndOfPeriod"] = "END_OF_PERIOD";
})(PaymentPeriodTiming || (exports.PaymentPeriodTiming = PaymentPeriodTiming = {}));
var PaymentType;
(function (PaymentType) {
    PaymentType["Cash"] = "CASH";
    PaymentType["CreditLine"] = "CREDIT_LINE";
    PaymentType["Financing"] = "FINANCING";
})(PaymentType || (exports.PaymentType = PaymentType = {}));
var PortalConfigurationType;
(function (PortalConfigurationType) {
    PortalConfigurationType["Aftermarket"] = "AFTERMARKET";
    PortalConfigurationType["CreditApplicationDetailModalCommercial"] = "CREDIT_APPLICATION_DETAIL_MODAL_COMMERCIAL";
    PortalConfigurationType["CreditApplicationDetailModalIndividual"] = "CREDIT_APPLICATION_DETAIL_MODAL_INDIVIDUAL";
    PortalConfigurationType["CreditReports"] = "CREDIT_REPORTS";
    PortalConfigurationType["Customers"] = "CUSTOMERS";
    PortalConfigurationType["Documents"] = "DOCUMENTS";
    PortalConfigurationType["HealthCheck"] = "HEALTH_CHECK";
    PortalConfigurationType["Insurance"] = "INSURANCE";
    PortalConfigurationType["InternalCreditTiers"] = "INTERNAL_CREDIT_TIERS";
    PortalConfigurationType["InvoiceAndEquipment"] = "INVOICE_AND_EQUIPMENT";
    PortalConfigurationType["Leads"] = "LEADS";
    PortalConfigurationType["Opportunities"] = "OPPORTUNITIES";
    PortalConfigurationType["Portal"] = "PORTAL";
    PortalConfigurationType["PortalSetup"] = "PORTAL_SETUP";
    PortalConfigurationType["PrescreenManagement"] = "PRESCREEN_MANAGEMENT";
    PortalConfigurationType["Recertification"] = "RECERTIFICATION";
    PortalConfigurationType["Scorecard"] = "SCORECARD";
    PortalConfigurationType["SecurityManagementMfa"] = "SECURITY_MANAGEMENT_MFA";
    PortalConfigurationType["SubmissionsHubManagement"] = "SUBMISSIONS_HUB_MANAGEMENT";
    PortalConfigurationType["UserManagement"] = "USER_MANAGEMENT";
    PortalConfigurationType["VoChecklistTemplate"] = "VO_CHECKLIST_TEMPLATE";
    PortalConfigurationType["VoManagement"] = "VO_MANAGEMENT";
    PortalConfigurationType["VoNotifications"] = "VO_NOTIFICATIONS";
    PortalConfigurationType["WorkflowsManagement"] = "WORKFLOWS_MANAGEMENT";
})(PortalConfigurationType || (exports.PortalConfigurationType = PortalConfigurationType = {}));
var PreFundingSource;
(function (PreFundingSource) {
    PreFundingSource["Bank"] = "Bank";
    PreFundingSource["Culver"] = "Culver";
})(PreFundingSource || (exports.PreFundingSource = PreFundingSource = {}));
var PrequalStatus;
(function (PrequalStatus) {
    PrequalStatus["Approved"] = "approved";
    PrequalStatus["Declined"] = "declined";
    PrequalStatus["Pending"] = "pending";
    PrequalStatus["PreApproved"] = "pre_approved";
    PrequalStatus["ProbationReview"] = "probation_review";
    PrequalStatus["ReviewRequired"] = "review_required";
})(PrequalStatus || (exports.PrequalStatus = PrequalStatus = {}));
var ProcessTriggerType;
(function (ProcessTriggerType) {
    ProcessTriggerType["CreditApplicationReceived"] = "CREDIT_APPLICATION_RECEIVED";
    ProcessTriggerType["CreditSubmissionReceived"] = "CREDIT_SUBMISSION_RECEIVED";
    ProcessTriggerType["CreditSubmissionUpdated"] = "CREDIT_SUBMISSION_UPDATED";
    ProcessTriggerType["VendorOpportunityUpdated"] = "VENDOR_OPPORTUNITY_UPDATED";
})(ProcessTriggerType || (exports.ProcessTriggerType = ProcessTriggerType = {}));
var ProcessType;
(function (ProcessType) {
    ProcessType["LenderWaterfall"] = "LENDER_WATERFALL";
    ProcessType["Workflow"] = "WORKFLOW";
})(ProcessType || (exports.ProcessType = ProcessType = {}));
var ProposalCategory;
(function (ProposalCategory) {
    ProposalCategory["LeadProposal"] = "LEAD_PROPOSAL";
    ProposalCategory["Proposal"] = "PROPOSAL";
    ProposalCategory["Quote"] = "QUOTE";
})(ProposalCategory || (exports.ProposalCategory = ProposalCategory = {}));
var ProposalContractAftermarketVendorDataStatus;
(function (ProposalContractAftermarketVendorDataStatus) {
    ProposalContractAftermarketVendorDataStatus["Error"] = "ERROR";
    ProposalContractAftermarketVendorDataStatus["Sent"] = "SENT";
    ProposalContractAftermarketVendorDataStatus["Success"] = "SUCCESS";
})(ProposalContractAftermarketVendorDataStatus || (exports.ProposalContractAftermarketVendorDataStatus = ProposalContractAftermarketVendorDataStatus = {}));
var ProposalMenuOptionType;
(function (ProposalMenuOptionType) {
    ProposalMenuOptionType["Common"] = "COMMON";
    ProposalMenuOptionType["Declination"] = "DECLINATION";
})(ProposalMenuOptionType || (exports.ProposalMenuOptionType = ProposalMenuOptionType = {}));
var ProposalSaleType;
(function (ProposalSaleType) {
    ProposalSaleType["CashWithAftermarketMenu"] = "CASH_WITH_AFTERMARKET_MENU";
    ProposalSaleType["FinanceOnly"] = "FINANCE_ONLY";
    ProposalSaleType["FinanceWithAftermarketMenu"] = "FINANCE_WITH_AFTERMARKET_MENU";
})(ProposalSaleType || (exports.ProposalSaleType = ProposalSaleType = {}));
var ProvidingInsuranceType;
(function (ProvidingInsuranceType) {
    ProvidingInsuranceType["ProvideOwn"] = "provide_own";
    ProvidingInsuranceType["ReceiveQuote"] = "receive_quote";
})(ProvidingInsuranceType || (exports.ProvidingInsuranceType = ProvidingInsuranceType = {}));
var QuoteAftermarketProductType;
(function (QuoteAftermarketProductType) {
    QuoteAftermarketProductType["Insurance"] = "INSURANCE";
    QuoteAftermarketProductType["Other"] = "OTHER";
    QuoteAftermarketProductType["Warranty"] = "WARRANTY";
})(QuoteAftermarketProductType || (exports.QuoteAftermarketProductType = QuoteAftermarketProductType = {}));
var QuoteFeeType;
(function (QuoteFeeType) {
    QuoteFeeType["CityTax"] = "CITY_TAX";
    QuoteFeeType["CountyTax"] = "COUNTY_TAX";
    QuoteFeeType["DocFee"] = "DOC_FEE";
    QuoteFeeType["FederalExciseTax"] = "FEDERAL_EXCISE_TAX";
    QuoteFeeType["Other"] = "OTHER";
    QuoteFeeType["StateTax"] = "STATE_TAX";
    QuoteFeeType["TireFee"] = "TIRE_FEE";
    QuoteFeeType["TitleFee"] = "TITLE_FEE";
    QuoteFeeType["VehicleInventoryTax"] = "VEHICLE_INVENTORY_TAX";
})(QuoteFeeType || (exports.QuoteFeeType = QuoteFeeType = {}));
var ReferenceType;
(function (ReferenceType) {
    ReferenceType["Bank"] = "BANK";
    ReferenceType["CorporateGuarantor"] = "CORPORATE_GUARANTOR";
    ReferenceType["Customer"] = "CUSTOMER";
    ReferenceType["Employment"] = "EMPLOYMENT";
    ReferenceType["EmploymentFuture"] = "EMPLOYMENT_FUTURE";
    ReferenceType["EmploymentPast"] = "EMPLOYMENT_PAST";
    ReferenceType["Insurance"] = "INSURANCE";
    ReferenceType["Loan"] = "LOAN";
    ReferenceType["Loc"] = "LOC";
    ReferenceType["Trade"] = "TRADE";
    ReferenceType["TradeThree"] = "TRADE_THREE";
    ReferenceType["TradeTwo"] = "TRADE_TWO";
})(ReferenceType || (exports.ReferenceType = ReferenceType = {}));
var RequiredStatusType;
(function (RequiredStatusType) {
    RequiredStatusType["Conditional"] = "CONDITIONAL";
    RequiredStatusType["Optional"] = "OPTIONAL";
    RequiredStatusType["Required"] = "REQUIRED";
})(RequiredStatusType || (exports.RequiredStatusType = RequiredStatusType = {}));
var ResidentStatusType;
(function (ResidentStatusType) {
    ResidentStatusType["CanadianCitizen"] = "CANADIAN_CITIZEN";
    ResidentStatusType["ForeignNational"] = "FOREIGN_NATIONAL";
    ResidentStatusType["Other"] = "OTHER";
    ResidentStatusType["UsCitizen"] = "US_CITIZEN";
})(ResidentStatusType || (exports.ResidentStatusType = ResidentStatusType = {}));
var SaleType;
(function (SaleType) {
    SaleType["Aftermarket"] = "AFTERMARKET";
    SaleType["Equipment"] = "EQUIPMENT";
    SaleType["Parts"] = "PARTS";
    SaleType["Rental"] = "RENTAL";
    SaleType["Service"] = "SERVICE";
})(SaleType || (exports.SaleType = SaleType = {}));
var SoftPullInDealerPortal;
(function (SoftPullInDealerPortal) {
    SoftPullInDealerPortal["CbcEquifaxSoftFullReport"] = "CBC_EQUIFAX_SOFT_FULL_REPORT";
    SoftPullInDealerPortal["CbcEquifaxSoftSummaryOnly"] = "CBC_EQUIFAX_SOFT_SUMMARY_ONLY";
    SoftPullInDealerPortal["Off"] = "OFF";
    SoftPullInDealerPortal["OnLegacyCrm"] = "ON_LEGACY_CRM";
    SoftPullInDealerPortal["Preview"] = "PREVIEW";
})(SoftPullInDealerPortal || (exports.SoftPullInDealerPortal = SoftPullInDealerPortal = {}));
var SourceType;
(function (SourceType) {
    SourceType["Dcr"] = "dcr";
    SourceType["Dealer"] = "dealer";
    SourceType["Lender"] = "lender";
})(SourceType || (exports.SourceType = SourceType = {}));
var SubmitProposalOptionActionType;
(function (SubmitProposalOptionActionType) {
    SubmitProposalOptionActionType["AcceptOption"] = "ACCEPT_OPTION";
    SubmitProposalOptionActionType["OcaRedirect"] = "OCA_REDIRECT";
})(SubmitProposalOptionActionType || (exports.SubmitProposalOptionActionType = SubmitProposalOptionActionType = {}));
var SubsidyCapType;
(function (SubsidyCapType) {
    SubsidyCapType["FixedAmount"] = "FIXED_AMOUNT";
    SubsidyCapType["NetInvoicePercentage"] = "NET_INVOICE_PERCENTAGE";
    SubsidyCapType["None"] = "NONE";
})(SubsidyCapType || (exports.SubsidyCapType = SubsidyCapType = {}));
var TaxTreatment;
(function (TaxTreatment) {
    TaxTreatment["Exempt"] = "Exempt";
    TaxTreatment["GrossReceipts"] = "Gross_Receipts";
    TaxTreatment["Upfront"] = "Upfront";
    TaxTreatment["Use"] = "Use";
})(TaxTreatment || (exports.TaxTreatment = TaxTreatment = {}));
var TiersType;
(function (TiersType) {
    TiersType["InternalTiers"] = "INTERNAL_TIERS";
    TiersType["Scorecard"] = "SCORECARD";
})(TiersType || (exports.TiersType = TiersType = {}));
var TruckType;
(function (TruckType) {
    TruckType["Fleet"] = "FLEET";
    TruckType["Heavy"] = "HEAVY";
    TruckType["LightMed"] = "LIGHT_MED";
})(TruckType || (exports.TruckType = TruckType = {}));
var UsCitizen;
(function (UsCitizen) {
    UsCitizen["ForeignNationalWithE2Visa"] = "FOREIGN_NATIONAL_WITH_E2_VISA";
    UsCitizen["UsCitizen"] = "US_CITIZEN";
    UsCitizen["UsFormedLegalEntity"] = "US_FORMED_LEGAL_ENTITY";
})(UsCitizen || (exports.UsCitizen = UsCitizen = {}));
var UserType;
(function (UserType) {
    UserType["Dealer"] = "dealer";
    UserType["Lender"] = "lender";
    UserType["PotentialCustomer"] = "potentialCustomer";
})(UserType || (exports.UserType = UserType = {}));
var VendorContactRole;
(function (VendorContactRole) {
    VendorContactRole["Admin"] = "admin";
    VendorContactRole["CreditMgr"] = "credit_mgr";
    VendorContactRole["Executive"] = "executive";
    VendorContactRole["SalesMgr"] = "sales_mgr";
    VendorContactRole["SalesRep"] = "sales_rep";
    VendorContactRole["SupportPerson"] = "support_person";
})(VendorContactRole || (exports.VendorContactRole = VendorContactRole = {}));
var VendorOpportunityStage;
(function (VendorOpportunityStage) {
    VendorOpportunityStage["ApplicationProcessing"] = "APPLICATION_PROCESSING";
    VendorOpportunityStage["Lead"] = "LEAD";
})(VendorOpportunityStage || (exports.VendorOpportunityStage = VendorOpportunityStage = {}));
var WebhookEventType;
(function (WebhookEventType) {
    WebhookEventType["CreditApplicationReceived"] = "CREDIT_APPLICATION_RECEIVED";
    WebhookEventType["CreditReportConsumerReceived"] = "CREDIT_REPORT_CONSUMER_RECEIVED";
    WebhookEventType["CreditReportConsumerUpdated"] = "CREDIT_REPORT_CONSUMER_UPDATED";
})(WebhookEventType || (exports.WebhookEventType = WebhookEventType = {}));
var InboundDealType;
(function (InboundDealType) {
    InboundDealType["MissedSale"] = "MISSED_SALE";
    InboundDealType["WebLead"] = "WEB_LEAD";
})(InboundDealType || (exports.InboundDealType = InboundDealType = {}));
